<template>
  <div>
    <NavTop :parentData="this.$route.params.tabBarId" class="navbar">
    </NavTop>
    <!-- 内容 -->
    <div class=" box content">
      <div class="box_l">
        <div class="box_l_item">
          <div class="item_img" style="background: #396194">
            <img src="../../assets/images/menu2_1.png" alt>
          </div>
          <div class="item_title">财务综合门户</div>
        </div>
        <div class="box_l_item">
          <div class="item_img" style="background: #31859d">
            <img src="../../assets/images/menu2_2.png" alt>
          </div>
          <div class="item_title">网上收费平台</div>
        </div>
        <div class="box_l_item">
          <div class="item_img" style="background: #f08e01">
          <img src="../../assets/images/menu2_3.png" alt>
        </div>
        <div class="item_title">一卡通服务中心</div>
      </div>
    </div>
    <div class="box_c">
      <div class="box_c_title">
        <span>{{ title.childName }}</span>
        <span v-if="title.appointTabId" @click="goTiaoZhuan(title.appointTabId)">
              查看更多
            </span>
        <span v-else @click="goTiaoZhuanSpan(title.parentId,title.id)">查看更多</span>
      </div>
      <div class="box_c_content">
        <ul>
          <li v-for="(item,index) in title.articleList" :key="index">
              <span class="box-c-title" v-if="title.appointTabId == null"
                    @click="routerpush(title.parentId,item.tabBarId,item.id)">
                  {{ item.title }}</span>
            <span v-else @click="routerpushSpan(title.appointTabId, item.id)">{{ item.title }}</span>
            <span>{{ extractDate(item.publishTime) }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="box_r">
      <div class="box_r_title">
        <span>{{ boxCenterData.childName }}</span>
        <span v-if="boxCenterData.appointTabId" @click="goTiaoZhuan(boxCenterData.appointTabId)">
              查看更多
            </span>
        <span v-else @click="goTiaoZhuanSpan(boxCenterData.parentId,boxCenterData.id)">查看更多</span>
      </div>
      <div class="box_r_list">
        <ul>
          <li v-for="(item,index) in boxCenterData.articleList" :key="index">
              <span v-if="boxCenterData.appointTabId" @click="routerpush(boxCenterData.parentId,item.tabBarId,item.id)">
                  {{ item.title }}</span>
            <span v-else @click="routerpushSpan(boxCenterData.appointTabId, item.id)">{{ item.title }}</span>
            <span>{{ extractDate(item.publishTime) }}</span>
            <span v-if="boxCenterData.appointTabId" @click="routerpush(boxCenterData.parentId,item.tabBarId,item.id)">
                  查看</span>
            <span v-else @click="routerpushSpan(boxCenterData.appointTabId, item.id)">查看</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- 友情链接 -->
  <div class="friendship">
    <div class="friendship_">
      <div class="friendship_title">
        <span>友情链接</span>
      </div>
      <div class="friendship_box">
        <img @click="goWaiLian('http://jyt.hebei.gov.cn/')" src="../../assets/images/01.png" alt>
        <img @click="goWaiLian('http://www.hbrsw.gov.cn/')" src="../../assets/images/02.png" alt>
        <img @click="goWaiLian('http://www.lfinfo.gov.cn/')" src="../../assets/images/03.png" alt>
        <img @click="goWaiLian('http://helf.lss.gov.cn/')" src="../../assets/images/04.png" alt>
      </div>
    </div>
  </div>
  </div>
</template>
<script>

import child from '../../api/child'

export default {
  data () {
    return {
      title: [],
      // http://jyt.hebei.gov.cn/
      // http://www.hbrsw.gov.cn/
      // http://www.lfinfo.gov.cn/
      // http://helf.lss.gov.cn/
      // 内容中间数据
      boxCenterData: []
    }
  },
  mounted () {

  },
  created () {
    this.getWenZhang(this.$route.params.tabBarId)
    // this.getNav(this.$route.params.tabBarId)
  },
  methods: {
    async getWenZhang (tabBarId) {
      const res = await child.getChild({tabBarId: tabBarId})
      if (res.code == 200) {
        let data = res.data
        this.title = data[0]
        // 支部建设数据
        this.boxCenterData = data[1]
      }
    },
    extractDate (dateTimeStr) {
      // 使用空格分割日期和时间
      const parts = dateTimeStr.split(' ')
      // 返回日期部分
      return parts[0]
    },
    goGengD (parentId, id) {
      this.$router.push({
        path: '/common/section/more' + '/' + parentId + '/' + id
      })
    },
    // 外连接
    goWaiLian(path){
      window.open(path, '_blank');
    },
    // 点击上方查看更多
    goTiaoZhuan (appointTabId) {
      let encodedId = encodeURIComponent(appointTabId)
      let decodedId = decodeURIComponent(encodedId)
      this.$router.push('/common/section/more' + decodedId)
    },
    goTiaoZhuanSpan (parentId, id) {
      this.$router.push('/common/section/more' + '/' + parentId + '/' + id)
    },
    routerpush (parentId, tabBarId, id) {
      this.$router.push('/common/section/detail' + '/' + parentId + '/' + tabBarId + '/' + id)
    },
    routerpushSpan (appointTabId, id) {
      let encodedId = encodeURIComponent(appointTabId)
      let decodedId = decodeURIComponent(encodedId)
      this.$router.push('/common/section/detail' + decodedId + '/' + id)
    },

  }
}
</script>
<style lang="less" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
}

// 内容
.box {
  height: 420px;
  margin-top: 35px;
  margin-bottom: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .box_l {
    width: 375px;
    height: 420px;
    overflow: hidden;

    .box_l_item {
      width: 100%;
      height: 120px;
      background: #f9f9f9;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;

      .item_img {
        width: 85px;
        height: 100%;
        background: #396194;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          cursor: pointer;
          position: relative;
        }
      }
    }

    .item_title {
      width: 260px;
      text-align: left;
    }
  }

  .box_c {
    width: 377px;
    height: 420px;
    border: 1px solid #eee;

    .box_c_title {
      margin-top: 30px;
      padding: 0 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        display: inline-block;

        &:nth-child(1) {
          font-size: 30px;
          text-align: left;
          font-weight: bold;
          position: relative;
          padding-bottom: 10px;
          color: #333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 55px;
            height: 2px;
            background: #9e070e;
          }
        }

        &:nth-child(2) {
          font-size: 16px;
          color: #666;
          position: relative;

          &:hover {
            cursor: pointer;
          }

          &::after {
            content: "";
            position: absolute;
            right: -10px;
            width: 8px;
            height: 8px;
            border: 1px solid #666;
            border-left: none;
            border-bottom: none;
            transform: rotate(45deg);
            top: 50%;
            margin-top: -4px;
          }
        }
      }
    }

    .box_c_content {
      width: 375px;
      height: 308px;
      padding-top: 10px;
      overflow: hidden;

      .box-c-title {
        width: 100%;
        display: block;
        text-decoration: none;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      ul {
        height: 100%;
        padding: 0 10px 0 30px;
        display: block;
        list-style-type: disc;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        padding-inline-start: 40px;

        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 50px;
          position: relative;

          &::before {
            content: '·';
            position: absolute;
            top: 45%;
            left: -15px;
            transform: translate(-50%, -50%) scale(2.5);
          }

          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            &:nth-child(1) {
              width: 67%;
              height: 100%;
              vertical-align: middle;
              line-height: 50px;

              &:hover {
                cursor: pointer;
                color: #9E070E;
              }
            }

            &:nth-child(2) {
              font-size: 14px;
              color: #666;
              width: 28%;
              text-align: right;
              display: inline-block;
              line-height: 50px;
            }
          }

        }
      }
    }
  }

  .box_r {
    width: 377px;
    height: 420px;
    border: 1px solid #eee;

    .box_r_title {
      margin-top: 30px;
      padding: 0 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        &:nth-child(1) {
          font-size: 30px;
          text-align: left;
          font-weight: bold;
          position: relative;
          padding-bottom: 10px;
          color: #333;

          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 55px;
            height: 2px;
            background: #9e070e;
          }
        }

        &:nth-child(2) {
          font-size: 16px;
          color: #666;
          position: relative;

          &:hover {
            cursor: pointer;
          }

          &::after {
            content: "";
            position: absolute;
            right: -10px;
            width: 8px;
            height: 8px;
            border: 1px solid #666;
            border-left: none;
            border-bottom: none;
            transform: rotate(45deg);
            top: 50%;
            margin-top: -4px;
          }
        }
      }
    }

    .box_r_list {
      width: 375px;
      height: 308px;
      padding-top: 10px;
      overflow: hidden;

      ul {
        height: 100%;
        padding: 0 10px 0 30px;
        display: block;
        list-style-type: disc;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        padding-inline-start: 40px;

        li {
          display: list-item !important;
          height: 50px;

          span {
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            &:nth-child(1) {
              width: 45% !important;
              height: 100%;
              vertical-align: middle;
              line-height: 50px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;

              &:hover {
                cursor: pointer;
                color: #9E0735;
              }
            }

            &:nth-child(2) {
              font-size: 14px;
              color: #666;
              display: inline-block;
              height: 100%;
              vertical-align: middle;
              line-height: 50px;
            }

            &:nth-child(3) {
              width: 20%;
              height: 100%;
              display: inline-block;
              vertical-align: middle;
              font-size: 12px;
              line-height: 50px;
              text-align: right;
              color: #666;

              &:hover {
                cursor: pointer;
                color: #9E0735;
              }
            }
          }
        }
      }
    }
  }
}

// 友情链接
.friendship {
  background: #f9f9f9;
  height: 240px;

  .friendship_ {
    width: 1200px;
    margin: 0 auto;

    .friendship_title {
      height: 100px;

      span {
        line-height: 100px;
        font-size: 28px;
        font-weight: bold;
        color: #333;
      }
    }

    .friendship_box {
      height: 95px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img{
        width: 286px;
        height: 87px;
      }
      img:hover {
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/bursar/office.vue